var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2.5 2.5 0l11 11 11-11L27 2.5l-11 11 11 11-2.5 2.5-11-11-11 11L0 24.5l11-11-11-11Z","fill":"currentColor"}));
}

Close.defaultProps = {"fill":"none","viewBox":"0 0 27 27"};

module.exports = Close;

Close.default = Close;
